import type { GossipGroup } from "@/types/content";

interface RankRowProps {
  group: GossipGroup;
}

const rankBadge = (rank: number) => {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-secondary-500 text-secondary-950";
  if (rank === 3) return "bg-accent-500 text-accent-950";
  return "bg-background-200 text-foreground-700";
};

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-600",
  down: "ri-arrow-down-line text-primary-600",
  flat: "ri-subtract-line text-foreground-400",
};

export default function RankRow({ group }: RankRowProps) {
  return (
    <div className="flex items-center gap-3 border-b border-background-200 px-3 py-3.5 transition-colors last:border-b-0 hover:bg-background-100 md:gap-4 md:px-4">
      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm ${rankBadge(group.rank)}`}
      >
        {group.rank}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="truncate font-label text-sm font-medium text-foreground-900 md:text-base">{group.name}</h3>
          <i className={`${trendIcon[group.trend] ?? trendIcon.flat} hidden text-sm sm:inline`}></i>
        </div>
        <p className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span className="rounded-full bg-background-100 px-2 py-0.5">{group.category}</span>
          <span>{group.platform}</span>
          <span className="hidden sm:inline">{group.members.toLocaleString("zh-CN")} 人</span>
        </p>
      </div>
      <div className="hidden w-32 shrink-0 flex-col gap-1 md:flex">
        <div className="flex items-center justify-between text-[11px] text-foreground-500">
          <span>活跃度</span>
          <span className="font-label font-semibold text-foreground-800">{group.activity}</span>
        </div>
        <span className="block h-1.5 w-full overflow-hidden rounded-full bg-background-200">
          <span className="block h-full rounded-full bg-accent-500" style={{ width: `${group.activity}%` }}></span>
        </span>
      </div>
      <div className="flex w-14 shrink-0 items-center justify-end gap-1 font-label text-sm font-semibold text-foreground-900">
        <i className="ri-star-fill text-secondary-500"></i>
        {group.rating.toFixed(1)}
      </div>
    </div>
  );
}